const CardInfo = ({ icon, title, value, color, bgColor }) => {
  return (
    <div className="
      flex items-center
      min-h-[7.5rem]
      gap-5
      rounded-2xl
      border border-slate-200
      bg-white
      px-6 py-5
      shadow-[0_8px_24px_rgba(15,23,42,0.08)]
    ">
      <div
        className={`
          flex
          h-[5rem] w-[5rem]
          shrink-0
          items-center justify-center
          rounded-full
          ${bgColor}
        `}
      >
        <div className={`h-10 w-10 fill-current ${color}`}>
          {icon}
        </div>
      </div>

      <div className="flex flex-col justify-center">
        <span className="text-lg font-medium leading-tight text-slate-900">
          {title}
        </span>

        <span
          className={`
            mt-2
            text-[2.25rem]
            font-bold
            leading-none
            tracking-tight
            text-slate-950
          `}
        >
          {value}
        </span>
      </div>
    </div>
  );
};

export default CardInfo;